/** Firebase `providerId` of each social sign-in provider, as Firebase Auth names it. */
export const SOCIAL_SIGN_IN_PROVIDER_IDS = {
    google: "google.com",
    facebook: "facebook.com",
    twitter: "twitter.com",
    github: "github.com",
    microsoft: "microsoft.com",
};
/**
 * Days a registered former guest account waits before it can send the
 * missions flagged `lockedAfterGuestUpgrade` (issue #332).
 */
export const GUEST_UPGRADE_MISSION_LOCK_DAYS = 3;
export const GUEST_UPGRADE_MISSION_LOCK_MS = GUEST_UPGRADE_MISSION_LOCK_DAYS * 24 * 60 * 60 * 1000;
/**
 * Cloudflare Turnstile actions. Each widget is rendered for one action and the
 * server checks the token was minted for the action it is guarding.
 */
export const TURNSTILE_ACTIONS = {
    guestSignUp: "guest-sign-up",
    guestSignIn: "guest-sign-in",
};
/** Why a guest can't found or join an alliance (issue #332). */
export const GUEST_ALLIANCE_MESSAGE = "Guest accounts can't found or join an alliance. Create an account to team up with other commanders.";
/**
 * Characters a guest ID is drawn from: digits and capitals without the
 * look-alikes 0/O, 1/I/L. Four groups of five give about 99 bits of
 * randomness, far too many to guess.
 */
export const GUEST_SIGN_IN_ID_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
export const GUEST_SIGN_IN_ID_GROUPS = 4;
export const GUEST_SIGN_IN_ID_GROUP_LENGTH = 5;
//# sourceMappingURL=auth.js.map